import { inject, Injectable } from '@angular/core';
import { Observable, Subscriber } from 'rxjs';
import { ID_FIELD_OPTIONS, WW_SAVED_SEARCH_COLLECTION } from '@damofire/data-commons';
import { collection, collectionData, Firestore, orderBy, query, where } from '@angular/fire/firestore';
import { ObservableSavedSearchService } from './saved-search-observable.service';
import { SavedSearch } from './saved-search.dto';
import { FirebaseWatsonObservableService } from '../firebase-watson-observable.service';
import { Issue } from '../issue/issue.dto';
import { FirebaseObservableServiceFactory } from '@damofire/data-angular-commons';
import { AuthenticationService, User } from '@damofire/data-security';

@Injectable()
export class FirebaseObservableSavedSearchService extends ObservableSavedSearchService {
  private readonly firebaseWatsonObservableService: FirebaseWatsonObservableService<SavedSearch>;
  private readonly firestore = inject(Firestore);

  constructor(
    private readonly firebaseObservableServiceFactory: FirebaseObservableServiceFactory,
    protected readonly appAuthService: AuthenticationService,
  ) {
    super();
    this.firebaseWatsonObservableService = new FirebaseWatsonObservableService<Issue>(firebaseObservableServiceFactory, WW_SAVED_SEARCH_COLLECTION);
  }

  list(divisionId: string): Observable<SavedSearch[]> {
    return new Observable<SavedSearch[]>((observer: Subscriber<SavedSearch[]>) => {
      this.appAuthService.currentUser().then((user: User) => {
        const queryFn = query(
          collection(this.firestore, WW_SAVED_SEARCH_COLLECTION),
          where('division._id', '==', divisionId),
          where('system', '==', false),
          where('audit.createdBy', '==', user._id),
          orderBy('name', 'asc'),
        );
        const sub = collectionData<SavedSearch>(queryFn, ID_FIELD_OPTIONS).subscribe((changes) => observer.next(changes));
        observer.add(sub);
      });
    });
  }

  get(divisionId: string, id: string): Observable<SavedSearch> {
    return this.firebaseWatsonObservableService.observeDoc(id);
  }
}
